export class ForecastedFreeCashFlowAfterTax {
  /**
   *
   * @param {Number} forecastedOwnerDiscretionaryEarnings
   * @param {Number} reasonableCompensation
   * @param {Number} ebitda
   * @param {Number} depreciation
   * @param {Number} stateIncomeTaxes
   * @param {Number} addDepreciation
   * @param {Number} growthWorkingCapital
   * @param {Number} capitalExpenditures
   */
  constructor({
    forecastedOwnerDiscretionaryEarnings,
    reasonableCompensation,
    depreciation,
    addDepreciation,
    growthWorkingCapital,
    capitalExpenditures,
    stateTax,
    federalTax
  }) {
    this.forecastedOwnerDiscretionaryEarnings = forecastedOwnerDiscretionaryEarnings
    this.reasonableCompensation = reasonableCompensation
    this.depreciation = depreciation
    this.addDepreciation = addDepreciation
    this.growthWorkingCapital = growthWorkingCapital
    this.capitalExpenditures = capitalExpenditures
    this.stateTax = stateTax
    this.federalTax = federalTax
  }

  get ebitda() {
    return this.forecastedOwnerDiscretionaryEarnings - this.reasonableCompensation
  }

  get nopat() {
    return this.normalizedIncomeAfterStateTaxes - this.federalIncomeTaxes
  }

  get ebit() {
    return this.ebitda - this.depreciation
  }

  get stateIncomeTaxes() {
    return this.ebit * (this.stateTax / 100)
  }

  get normalizedIncomeAfterStateTaxes() {
    return this.ebit - this.stateIncomeTaxes
  }

  get federalIncomeTaxes() {
    return this.normalizedIncomeAfterStateTaxes * (this.federalTax / 100)
  }

  get afterTaxFreeCashFlow() {
    return (
      this.nopat + this.addDepreciation - this.growthWorkingCapital - this.capitalExpenditures
    )
  }
}

export class ForecastedFreeCashFlowBeforeTax {
  /**
   *
   * @param {Number} forecastedOwnerDiscretionaryEarnings
   * @param {Number} reasonableCompensation
   * @param {Number} growthWorkingCapital
   * @param {Number} capitalExpenditures
   */
  constructor({
    forecastedOwnerDiscretionaryEarnings,
    reasonableCompensation,
    growthWorkingCapital,
    capitalExpenditures,
  }) {
    this.forecastedOwnerDiscretionaryEarnings = forecastedOwnerDiscretionaryEarnings
    this.reasonableCompensation = reasonableCompensation
    this.growthWorkingCapital = growthWorkingCapital
    this.capitalExpenditures = capitalExpenditures
  }

  get ebitda() {
    return this.forecastedOwnerDiscretionaryEarnings - this.reasonableCompensation
  }

  get preTaxFreeCashFlow() {
    return this.ebitda - this.growthWorkingCapital - this.capitalExpenditures
  }
}

export default class ForecastedFreeCashFlow {
  /**
   *
   * @param {ForecastedFreeCashFlowAfterTax} forecastedFreeCashFlowAfterTax
   * @param {ForecastedFreeCashFlowBeforeTax} forecastedFreeCashFlowBeforeTax
   */
  constructor({
    forecastedFreeCashFlowAfterTax,
    forecastedFreeCashFlowBeforeTax
  }) {
    this.forecastedFreeCashFlowAfterTax = forecastedFreeCashFlowAfterTax
    this.forecastedFreeCashFlowBeforeTax = forecastedFreeCashFlowBeforeTax
  }
}